import { useEffect, useState } from 'react';
import { ApplicationProvider } from './shared';
import { ApolloProvider } from '@apollo/client';
import ApplicationContainer from 'shared/ApplicationContainer';
import { ViewportProvider } from 'shared/ViewportProvider';
import { BrowserRouter } from 'react-router-dom';
import useAppApolloClient from 'lib/client';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: `https://6c2136564551e2eabf943e427a86043d@${window.location.host}/api/sentry/6`
});

const AutoRefreshingRouter = ({ children }: any) => {
  const [shouldRefresh, setShouldRefresh] = useState(false);

  useEffect(() => {
    const id = setTimeout(
      () => setShouldRefresh(true),
      1000 * 60 * 60 * 1 // 6 hours in milliseconds
    );
    return () => clearTimeout(id);
  }, []);

  return (
    <BrowserRouter forceRefresh={shouldRefresh}>
      {children}
    </BrowserRouter>
  );
}

const App = () => {
  const client = useAppApolloClient();

  return (
    <ViewportProvider>
      <ApplicationProvider>
        <ApolloProvider client={client}>
          <AutoRefreshingRouter>
            <ApplicationContainer />
          </AutoRefreshingRouter>
        </ApolloProvider>
      </ApplicationProvider>
    </ViewportProvider>
  );
}

export default App;
